function distToSegment(p, p1, p2) {
  const A = p.x - p1.x;
  const B = p.y - p1.y;
  const C = p2.x - p1.x;
  const D = p2.y - p1.y;
  const dot = A * C + B * D;
  const lenSq = C * C + D * D;
  let param = lenSq ? dot / lenSq : -1;
  param = Math.max(0, Math.min(1, param));
  const xx = p1.x + param * C;
  const yy = p1.y + param * D;
  const dx = p.x - xx;
  const dy = p.y - yy;
  return Math.sqrt(dx * dx + dy * dy);
}

export default distToSegment;
